// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { SelectButton } from "metabase/common/components/SelectButton/SelectButton";

export const DashboardPickerButton = styled(SelectButton)`
  font-weight: 400;
`;
